import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import chooseImg from "../../assets/images/image-4.svg";

const features = [
  {
    title: "Experienced Engineering Team",
    desc: "Our team brings deep expertise across RTL design, verification, physical design, DFT, and STA with proven success.",
  },
  {
    title: "End-to-End VLSI Services",
    desc: "From architecture to GDSII, we provide turnkey services and resource augmentation tailored to client needs.",
  },
  {
    title: "Advanced Technology Nodes",
    desc: "Expertise in cutting-edge nodes including 3nm, 5nm, and 7nm for high-performance designs.",
  },
  {
    title: "Customer-Centric Approach",
    desc: "We focus on quality, innovation, and long-term partnerships to ensure customer success.",
  },
];

const WhyChooseUs: React.FC = () => {
  return (
    <section className="why-section">
      <Container>
        <Row className="align-items-center">
          {/* Left Image */}
          <Col lg={6} className="mb-4 mb-lg-0 text-center">
            <div className="why-img-wrapper">
              <img src={chooseImg} alt="Why Choose Us" />
              <Button className="why-btn">GET STARTED →</Button>
            </div>
          </Col>

          {/* Right Content */}
          <Col lg={6}>
            <span className="why-badge">WHY CHOOSE US</span>
            <h2 className="why-title">
              Why Core Semicon Technologies <br /> Stands Out
            </h2>
            <p className="why-desc">
              At Core Semicon Technologies, we are committed to shaping your
              career in the semiconductor and electronics industries. Here’s
              what sets us apart:
            </p>

            <Row>
              {features.map((item, idx) => (
                <Col md={6} key={idx} className="mb-4">
                  <Card className="why-card h-100">
                    <Card.Body>
                      <div className="why-card-header">
                        <i className="bi bi-check-circle why-icon"></i>{" "}
                        <h5>{item.title}</h5>
                      </div>
                      <p>{item.desc}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhyChooseUs;
